import MuiChip from '@mui/material/Chip'
import styled from '@mui/material/styles/styled'

export const FilterChip = styled(MuiChip, {
  name: 'FilterChip',
  slot: 'Root',
  skipSx: true,
})`
  border: none;
  color: #19305a;
  line-height: 18px;
  padding-bottom: 10px;
`
